import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue").then(m => m.default || m)),
  "pre-auth": defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/pre-auth.vue").then(m => m.default || m)),
  "with-cart": defineAsyncComponent(() => import("/opt/atlassian/pipelines/agent/build/layouts/with-cart.vue").then(m => m.default || m))
}